// RenderPolicyDetails.js
import React from "react";
import { formatDateTime } from "../../components/FormattedTime/FormatDateTime";

const RenderPolicyDetails = ({ data }) => {
  const insuranceType = data?.order_details?.insurance_type;
  let personalInfo = {};

  switch (insuranceType) {
    case 1:
      personalInfo = data.foreign_worker_insurance || {};
      break;
    case 2:
      personalInfo = data.term_life_insurance || {};
      break;
    case 3:
      personalInfo = data.health_insurance || {};
      break;
    case 4:
      personalInfo = data.pa_insurance || {};
      break;
    case 5:
      personalInfo = data.motor_insurance || {};
      break;
    case 6:
      personalInfo = data.offshore_insurance || {};
      break;
    case 7:
      personalInfo = data.group_insurance || {};
      break;
    case 8:
      personalInfo = data.property_insurance || {};
      break;
    default:
      personalInfo = {};
  }

  const {
    id,
    order_id,
    subscription_plan_name,
    status,
    policy_start_date,
    policy_end_date,
    created_at,
    cover_note_no,
    order_data,
    policy_docs,
  } = data || {};

  return (
    <>
      <div className="col-md-4 mb-3">
        <label className="form-label">Policy ID:</label>
        <p>
          <b>{id || "N/A"}</b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Order ID:</label>
        <p>
          <b>{order_id || "N/A"}</b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Plan Name:</label>
        <p>
          <b>{subscription_plan_name || order_data?.insurance_plan || personalInfo.plan_name || "N/A"}</b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Policy Status:</label>
        <p>
          <b>{status || "N/A"}</b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Premium Amount:</label>
        <p>
          <b>{personalInfo.premium || personalInfo.basic_premium || "N/A"}</b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Amount Paid (RM):</label>
        <p>
          <b>{"N/A"}</b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Policy Start Date</label>
        <p>
          <b>
            {policy_start_date
              ? formatDateTime(policy_start_date)
              : "N/A"}
          </b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Policy End Date</label>
        <p>
          <b>
            {policy_end_date
              ? formatDateTime(policy_end_date)
              : "N/A"}
          </b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Policy Created Date:</label>
        <p>
          <b>
            {created_at
              ? formatDateTime(created_at)
              : "N/A"}
          </b>
        </p>
      </div>
      <div className="col-md-4 mb-3">
        <label className="form-label">Cover Note No:</label>
        <p>
          <b>{cover_note_no || "N/A"}</b>
        </p>
      </div>
      <div className="col-md-8 mb-3">
        <label className="form-label">Policy Documents:</label>
        {policy_docs && policy_docs.length > 0 ? (
          policy_docs.map((doc) => (
            <div key={doc.id}>
              <a href={doc.document} target="_blank" rel="noopener noreferrer">
                {doc.document.split("/").pop()}
              </a>
            </div>
          ))
        ) : (
          <p><b>N/A</b></p>
        )}
      </div>
    </>
  );
};

export default RenderPolicyDetails;
